import { gql } from 'apollo-angular';

export const GET_PUBLIC_CARD_BY_ID = gql`
  query GetPlayerCardViewData($cardId: ObjectId!) {
    getPlayerCardViewData(cardId: $cardId) {
      cards {
        columnCount
        id
        items {
          consumed
        }
        name
        positions
        pricePerPosition
        productImages
        products {
          _id
          code
          costPrice
          createdAt
          imageDataUrl
          imageUrl
          name
          sellPrice
          sellerId
          tags
          updatedAt
        }
        rowCount
      }
    }
  }
`;

export const PUBLIC_SELLER_CARD_ORDER_BY_ID = gql`
  query PublicSellerCardOrderById($orderId: ObjectId!) {
    publicSellerCardOrderById(orderId: $orderId) {
      _id
      cardsAvailable
      createdAt
      items {
        _id
        amount
        code
        name
        price
      }
      payment
      sellerId
      status {
        _id
        description
        name
      }
      statusId
      totalPrice
      updatedAt
    }
  }
`;

export const LIST_PUBLIC_CARDS = gql`
  query ListSellerCards($search: String, $filters: CardEntityFilters, $page: PageInput) {
    listSellerCards(search: $search, filters: $filters, page: $page) {
      data {
        _id
        name
        status
      }
      pagination {
        page
        size
        totalPages
        totalItems
        pageItemCount
        pageOffset
      }
    }
  }
`;
